import { useEffect, useRef, useState } from "react";
import UniBtn, { UniBtnPack } from "./UniBtn";
import { Easy69_v1 } from "../utils/frfr-easy69-utils";
import { _zzyourmap_extract_editorjs_renderable_data } from "../utils/zz/zz-yourmap-blog-post-utils";
import { yourmapNavMaker, _zzyourmap_routing_browser_title_update, _zzyourmap_routing_routeState_to_path, _zzyourmap_routing_static_pages_keys, _zzyourmap_routing_tab_keys } from "../utils/zz/zz-yourmap-routing";
import { _zzyourmap_config } from "../utils/zz/zz-yourmap-config";
import UniPair from "./UniPair";
import UniLink from "./UniLink";
import Slider from "react-slick";


// DEFAULT COMPONENT
const YourmapSlider = (props) => {
  const main_img_src = props.main_img_src;
  const slide_img_src_arr = props.slide_img_src_arr;
  const showHeroTitle = props.showHeroTitle !== false;

  const style = {
    // backgroundImage: 'url("https://ymdemo2.applabz.work/uploads/2025-11-30_img_692d2f80c5777.jpg")',
    backgroundImage: 'url("' + main_img_src + '")',
  };

  // slick slider
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  let sliderRef1 = useRef(null);
  let sliderRef2 = useRef(null);
  useEffect(() => {
    setNav1(sliderRef1);
    setNav2(sliderRef2);
  }, []);

  return (
    <>
      <div className="yourmap__slick-slider-wrapper unirole-scope-without-default-transition">
        {/*
        <section className="yourmap__section">
          <div className="inner">
            <div className="slider-container">
              <h2>Slider Syncing (AsNavFor)</h2>
              <h4>First Slider</h4>
              <Slider asNavFor={nav2} ref={slider => (sliderRef1 = slider)}>
                {
                  slide_img_src_arr.map((src, index) => {
                    return (
                      <div key={index}>
                        <div className="yourmap__slick-slider__thumb">
                          <img src={src} />
                        </div>
                      </div>
                    );
                  })
                }
              </Slider>
              <h4>Second Slider</h4>
              <Slider
                asNavFor={nav1}
                ref={slider => (sliderRef2 = slider)}
                slidesToShow={3}
                swipeToSlide={true}
                focusOnSelect={true}
                variableWidth={true}
              >
                {
                  demo_img_arr.map((src, index) => {
                    return (
                      <div key={index}>
                        <div className="yourmap__slick-slider__thumb">
                          <img src={src} />
                        </div>
                      </div>
                    );
                  })
                }
                <div>
                  <div className="yourmap__slick-slider__thumb">
                    <h3>1</h3>
                  </div>
                </div>
                <div>
                  <div className="yourmap__slick-slider__thumb">
                    <h3>2</h3>
                  </div>
                </div>
                <div>
                  <div className="yourmap__slick-slider__thumb">
                    <h3>3</h3>
                  </div>
                </div>
                <div>
                  <div className="yourmap__slick-slider__thumb">
                    <h3>4</h3>
                  </div>
                </div>
                <div>
                  <div className="yourmap__slick-slider__thumb">
                    <h3>5</h3>
                  </div>
                </div>
                <div>
                  <div className="yourmap__slick-slider__thumb">
                    <h3>6</h3>
                  </div>
                </div>
                <div>
                  <div className="yourmap__slick-slider__thumb">
                    <h3>7</h3>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </section>
        */}

        <section className="yourmap__section">
          <div className="inner">
            <div className="uu-gap-standalone-05rem"></div>
            <div className="yourmap__card yourmap__card--big-cover">
              <div className="yourmap__card__overlay-1">
                <Slider
                  asNavFor={nav2}
                  ref={slider => (sliderRef1 = slider)}
                  slidesToShow={1}
                  swipeToSlide={true}
                  swipe={true}
                  slidesToScroll={1}
                  fade={false}
                >
                  {
                    Array.isArray(slide_img_src_arr) && slide_img_src_arr.map((src, index) => {
                      const style = {
                        // backgroundImage: 'url("https://ymdemo2.applabz.work/uploads/2025-11-30_img_692d2f80c5777.jpg")',
                        backgroundImage: 'url("' + src + '")',
                      };
                      return (
                        <div key={index}>
                          <div className="yourmap__slick-slider__thumb yourmap__slick-slider__thumb--big">
                            <div className="yourmap__slick-slider__thumb__img-bg" style={style}></div>
                          </div>
                        </div>
                      );
                    })
                  }
                </Slider>
              </div>
              <div className="yourmap__card__overlay-2"></div>
              {showHeroTitle && (
                <div className="yourmap__card-destinacija-content">
                  <div className="yourmap__article__title-and-subtitle">
                    <div className="uu-gap-standalone-1rem"></div>
                    <h1>{props.hero_title}</h1>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>

        <section className="yourmap__section">
          <div className="inner">
            <div className="uu-gap-standalone-8px"></div>
            <div className={"yourmap__slick-slider__thumbnails-slider-container" + (slide_img_src_arr?.length < 2 ? " uu-display-none" : "")}>
              <div className="">
                {/*
                ={nav1}
                ref={slider => (sliderRef2 = slider)}
                slidesToShow={3}
                swipeToSlide={true}
                focusOnSelect={true}
                variableWidth={true}
                */}
                <Slider
                  asNavFor={nav1}
                  ref={slider => (sliderRef2 = slider)}
                  slidesToShow={3}
                  swipeToSlide={true}
                  focusOnSelect={true}
                  variableWidth={true}
                >
                  {
                    Array.isArray(slide_img_src_arr) && slide_img_src_arr.map((src, index) => {
                      return (
                        <div key={index}>
                          <div className="yourmap__slick-slider__thumb">
                            <img src={src} />
                          </div>
                        </div>
                      );
                    })
                  }
                  {/*
                <div className="xi">
                  <div className="yourmap__slider__thumb">1</div>
                </div>
                <div className="xi">
                  <div className="yourmap__slider__thumb">2</div>
                </div>
                */}
                </Slider>

              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default YourmapSlider;